module.exports = __webpack_public_path__ + "img/check.ef22c03c.svg";